import { render, staticRenderFns } from "./ReportCenter.vue?vue&type=template&id=28c411d2&scoped=true"
import script from "./ReportCenter.vue?vue&type=script&lang=js"
export * from "./ReportCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c411d2",
  null
  
)

export default component.exports